export default __webpack_public_path__ + "static/media/IBMDocumentAttachment.e18317ce.svg";